import { render, staticRenderFns } from "./deliveryorderlist.vue?vue&type=template&id=f5e5ed72&scoped=true&"
import script from "./deliveryorderlist.vue?vue&type=script&lang=js&"
export * from "./deliveryorderlist.vue?vue&type=script&lang=js&"
import style0 from "./deliveryorderlist.vue?vue&type=style&index=0&id=f5e5ed72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e5ed72",
  null
  
)

export default component.exports